import { Tag, Tooltip } from 'antd';

import { LeadTag } from 'models/Lead';

import { splitVisibleTags } from 'utils/LeadTagGridHelper';

interface LeadTagsCellProps {
  tags?: LeadTag[];
}

function LeadTagsCell({ tags }: LeadTagsCellProps) {
  const { visible, hidden } = splitVisibleTags(tags);

  if (visible.length === 0) {
    return <span className="lead-cell-secondary">—</span>;
  }

  return (
    <div className="lead-tags-cell">
      {visible.map((tag) => (
        <Tag key={tag.id} style={{ margin: 0 }}>
          {tag.name}
        </Tag>
      ))}
      {hidden.length > 0 && (
        <Tooltip
          title={hidden.map((tag) => (
            <div key={tag.id}>{tag.name}</div>
          ))}
        >
          <Tag style={{ margin: 0 }}>+{hidden.length}</Tag>
        </Tooltip>
      )}
    </div>
  );
}

export default LeadTagsCell;
